import { forwardRef, useEffect, useRef, useCallback } from 'react'
import { useMediaQueries } from 'builder/hooks/useMediaQueries'
import { PromptInput } from './styles'

const AutoExpandingPromptInput = forwardRef<HTMLTextAreaElement, React.ComponentProps<'textarea'>>(
  (props, ref) => {
    const { onKeyDown, ...restProps } = props
    const textareaRef = useRef<HTMLTextAreaElement | null>(null)
    const { isPhone } = useMediaQueries()

    const adjustHeight = useCallback(() => {
      const textarea = textareaRef.current
      if (textarea) {
        textarea.style.height = '64px'
        textarea.style.height = `${Math.min(textarea.scrollHeight, 200)}px`
      }
    }, [])

    useEffect(() => {
      adjustHeight()
    }, [adjustHeight])

    const handleKeyDown = useCallback(
      (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
        if (e.key === 'Enter' && !isPhone && !e.shiftKey) {
          e.preventDefault()
          e.currentTarget.form?.requestSubmit()
        }

        onKeyDown?.(e)
      },
      [onKeyDown, isPhone],
    )

    const setRef = useCallback(
      (el: HTMLTextAreaElement | null) => {
        textareaRef.current = el

        if (typeof ref === 'function') {
          ref(el)
        } else if (ref) {
          ref.current = el
        }
      },
      [ref],
    )

    return (
      <PromptInput
        ref={setRef}
        {...restProps}
        rows={1}
        onInput={adjustHeight}
        onKeyDown={handleKeyDown}
      />
    )
  },
)

export default AutoExpandingPromptInput
